import styled from 'styled-components';
import { ReactComponent as UploadIcon } from '../../../icons/upload.svg';

export const StyledUploadIcon = styled(UploadIcon)`
  width: 18px;
  height: 18px;
`;
